export default class TableColumn {

  constructor(param: any = {}) {
    const valid = param && typeof param === 'object' && !Array.isArray(param);

    if (valid) {
      const {name, position, sorting, width, key} = param;

      this.name = name || '';
      this.position = position || null;
      this.sorting = sorting || false;
      this.width = width || null;
      this.key = key || null;
    }
  }

  public name: string = '';

  public position: any = null;

  public sorting: boolean = false;

  public width: any = null;

  public key: any = null;
}